import React from 'react';
import { ConfirmationWithRadio } from 'components/Dialogs';

function confirmationWithRadioWrapper(props) {
  return () => <ConfirmationWithRadio {...props} />;
}

export default confirmationWithRadioWrapper;
